import { render, staticRenderFns } from "./MediaTextBlock.vue?vue&type=template&id=119c53a7&scoped=true&"
import script from "./MediaTextBlock.vue?vue&type=script&lang=js&"
export * from "./MediaTextBlock.vue?vue&type=script&lang=js&"
import style0 from "./MediaTextBlock.vue?vue&type=style&index=0&id=119c53a7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119c53a7",
  null
  
)

export default component.exports